import { ReactNode, ReactElement } from "react";

export function LabelText({
  children,
  requiredIndicator,
}: {
  children: ReactNode;
  requiredIndicator?: boolean;
}): ReactElement {
  return (
    <span className="label">
      {requiredIndicator && <span aria-hidden>* </span>}
      {children}
    </span>
  );
}
